import { useEffect, useRef, useState } from 'react'

export function useScrollIntoViewOnHighlight<
  T extends HTMLElement = HTMLElement,
>(
  highlighted: boolean,
  scrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'end',
  },
) {
  const ref = useRef<T>(null)
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        setIsKeyboardNavigation(true)
      }
    }

    const handleMouseMove = () => {
      setIsKeyboardNavigation(false)
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('mousemove', handleMouseMove)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  useEffect(() => {
    if (highlighted && isKeyboardNavigation && ref.current) {
      ref.current.scrollIntoView(scrollOptions)
    }
  }, [highlighted, isKeyboardNavigation, scrollOptions])

  return ref
}
